import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Polygon,
  Tooltip,
} from "react-leaflet";
import { Loading } from "@components";
import { Currency } from "shared/utils/Currency";

const KMLMap = ({ kml, addressOptions }) => {
  const [mapLoaded, setMapLoaded] = useState(false);

  const MapMarker = ({ position, iconUrl }) => {
    const icon = new L.Icon({
      iconUrl: iconUrl || require("../../../../assets/location.png"),
    });

    return <Marker position={position} icon={icon} />;
  };

  const AdjustMapSize = ({ onLoaded }) => {
    const map = useMap();

    useEffect(() => {
      map.invalidateSize();
      onLoaded();
    }, [map, onLoaded]);

    return null;
  };

  const extractPrice = (string) => {
    if (!string || typeof string !== "string") return null;

    const match = string.match(/([-+]?\d+[.,]?\d*)/);

    if (match) {
      const price = match[0].replace(",", ".");
      return Number.parseFloat(price);
    }
    return null;
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      {!mapLoaded && (
        <div className="d-flex align-center justify-center">
          <Loading />
        </div>
      )}

      {addressOptions.geolocation && (
        <MapContainer
          style={{ width: "100%", height: "100%" }}
          center={[
            addressOptions.geolocation?.latitude,
            addressOptions.geolocation?.longitude,
          ]}
          zoom={13}
          minZoom={6}
          maxZoom={15}
          attributionControl={false}
          zoomControl={false}
          doubleClickZoom={true}
          scrollWheelZoom={true}
        >
          <TileLayer url="https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=s.e%3Ag%7Cp.c%3A%23ff242f3e%2Cs.e%3Al.t.f%7Cp.c%3A%23ff746855%2Cs.e%3Al.t.s%7Cp.c%3A%23ff242f3e%2Cs.t%3A19%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A2%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A40%7Cs.e%3Ag%7Cp.c%3A%23ff263c3f%2Cs.t%3A40%7Cs.e%3Al.t.f%7Cp.c%3A%23ff6b9a76%2Cs.t%3A3%7Cs.e%3Ag%7Cp.c%3A%23ff38414e%2Cs.t%3A3%7Cs.e%3Ag.s%7Cp.c%3A%23ff212a37%2Cs.t%3A3%7Cs.e%3Al.t.f%7Cp.c%3A%23ff9ca5b3%2Cs.t%3A49%7Cs.e%3Ag%7Cp.c%3A%23ff746855%2Cs.t%3A49%7Cs.e%3Ag.s%7Cp.c%3A%23ff1f2835%2Cs.t%3A49%7Cs.e%3Al.t.f%7Cp.c%3A%23fff3d19c%2Cs.t%3A4%7Cs.e%3Ag%7Cp.c%3A%23ff2f3948%2Cs.t%3A66%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A6%7Cs.e%3Ag%7Cp.c%3A%23ff17263c%2Cs.t%3A6%7Cs.e%3Al.t.f%7Cp.c%3A%23ff515c6d%2Cs.t%3A6%7Cs.e%3Al.t.s%7Cp.c%3A%23ff17263c" />

          {kml?.map((polygon, index) => {
            const deliveryFee = extractPrice(polygon.description);

            return (
              <div className={{ zIndex: -1 }}>
                <Polygon
                  key={index}
                  pathOptions={{
                    color: polygon.stroke || "var(--default)",
                    fillColor: polygon.fill || "var(--background-secondary)",
                    fillOpacity: polygon["fill-opacity"] || 0.5,
                    weight: polygon["stroke-width"] || 1,
                  }}
                  positions={polygon.points}
                >
                  <Tooltip permanent direction="center" className="tooltipKml">
                    <div
                      style={{
                        fontSize: "12px",
                        padding: "4px 8px",
                        fontWeight: "bold",
                        color: "#fff",
                      }}
                    >
                      {polygon.name && <p>{polygon.name}</p>}
                      {deliveryFee && (
                        <span style={{ color: "#ccc" }}>
                          Taxa {Currency.formatCurrency(deliveryFee)}
                        </span>
                      )}
                    </div>
                  </Tooltip>
                </Polygon>
              </div>
            );
          })}

          <AdjustMapSize onLoaded={() => setMapLoaded(true)} />

          <MapMarker
            position={[
              addressOptions.geolocation?.latitude,
              addressOptions.geolocation?.longitude,
            ]}
          />
        </MapContainer>
      )}
    </div>
  );
};

export default KMLMap;
